<template>
	<!-- 预出库汇总 -->
	<div class="preDeliverySummary">
		<!-- 导出模板 -->
		<div id="export" style="position: fixed;top: -9999999px;">
			<div class="export-template">
				<div :id="'template-title'">
					<div style="line-height: 50px;font-size: 22px;" align=center>
						<strong>
							<font>配货订单商品明细</font>
							<!-- <font>{{ routeName }}-配送商品汇总</font> -->
						</strong>
					</div>
				</div>
				<div class="title-box">
					<div class="box-l">
						<div class="l-item">
							<span>配货日期：{{ searchForm.dateVal }}</span>
						</div>
					</div>
				</div>
				<div :id="'template-table'">
					<table border=1 cellSpacing=0 cellPadding=1 width="100%" style="border-collapse:collapse"
						bordercolor="#333333">
						<thead>
							<tr>
								<td width="15%">
									<div align=center><b>序号</b></div>
								</td>
								<td width="70%">
									<div align=center><b>商品名称</b></div>
								</td>
								<td width="15%">
									<div align=center><b>数量</b></div>
								</td>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in selectionList" :key="index">
								<td align=center>{{ index + 1 }}</td>
								<td align=center>{{ item.goods_name }}</td>
								<td align=center>{{ item.count }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="search">
			<div class="search-l">
				<div class="l-item" style="width: 40%;">
					<div class="item-label" style="width: 90px;">配货日期:</div>
					<div class="item-input" style="width: 80%;">
						<el-date-picker v-model="dateVal" type="daterange" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 100%;">
						</el-date-picker>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label" style="width: 90px;">配货单号:</div>
					<div class="item-input">
						<el-input v-model="searchForm.sn" placeholder="请输入配送单号" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label" style="width: 90px;">联系人:</div>
					<div class="item-input">
						<el-input v-model="searchForm.contacts" placeholder="请输入联系人" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label" style="width: 90px;">电话:</div>
					<div class="item-input">
						<el-input v-model="searchForm.phone" placeholder="请输入电话" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label" style="width: 90px;">地址:</div>
					<div class="item-input">
						<el-input v-model="searchForm.address" placeholder="请输入地址" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label" style="width: 90px;">单据类型:</div>
					<div class="item-input">
						<el-select v-model="searchForm.type" placeholder="请选择单据类型">
							<el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label" style="width: 90px;">商品状态:</div>
					<div class="item-input">
						<el-select v-model="searchForm.status" placeholder="请选择商品状态">
							<el-option v-for="item in statusType" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label" style="width: 90px;">商品名称:</div>
					<div class="item-input">
						<el-input v-model="searchForm.goods_name" placeholder="请输入商品名称" ref="inputGoods" />
					</div>
				</div>
				<div class="l-item">
					<div class="item-label" style="width: 90px;">商品分类</div>
					<div class="item-input">
						<el-select v-model="selectCate" multiple collapse-tags style="margin-left: 20px;"
							placeholder="请选择">
							<el-option v-for="item in cateList" :key="item.id" :label="item.title" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<div class="item-label" style="width: 90px;">配货仓库</div>
					<div class="item-input">
						<el-select v-model="searchForm.warehouse_id" placeholder="请选择">
							<el-option v-for="item in warehouseOptions" :key="item.id" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="l-item">
					<el-button type="warning" @click.stop="handleSearch">搜索</el-button>
					<el-button
						@click.stop="pageNum = 10, selectCate = [], searchForm = {}, searchForm.begin = dateVal[0], searchForm.end = dateVal[1], handleSearch()">重置</el-button>
				</div>
				<i></i>
				<i></i>
				<i></i>
				<i></i>
			</div>
		</div>
		<div class="table">
			<div class="table-operation">
				<el-button type="warning" @click.stop="handleDelay(1)">批量延期</el-button>
				<el-button type="danger" @click.stop="handleCancel(1)">批量取消</el-button>
				<!-- 				<el-button type="success" @click.stop="handleExport">导出提货人明细</el-button> -->
				<div style="margin:0 10px;display: inline;">
					<el-dropdown @command="handleExport">
						<el-button type="success">
							导出提货人明细<i class="el-icon-arrow-down el-icon--right"></i>
						</el-button>

						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1">按提货人姓名排序</el-dropdown-item>
							<el-dropdown-item command="2">按手机后四位排序</el-dropdown-item>
						</el-dropdown-menu>

					</el-dropdown>
				</div>
				<el-button type="info" icon="el-icon-refresh-left" @click.stop="loading = true, getList()"></el-button>
				<span style="color:#F56C6C;padding-left:20px">按配货单显示待确认和已确认的商品</span>
			</div>
			<Table :data="tableData" :total="total" v-loading="loading"
				@size-change="pageNum = $event, loading = true, getList()"
				@current-change="page = $event, loading = true, getList()" @selection-change="selectionChange">
				<el-table-column type="selection" width="55"></el-table-column>
				<el-table-column prop="date" label="配货日期" align="center" width="120"></el-table-column>
				<el-table-column prop="sn" label="配货单号" align="center" width="150"></el-table-column>
				<el-table-column label="创建类型" align="center" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.type == 1">正常</span>
						<span v-if="scope.row.type == 2">延期</span>
					</template>
				</el-table-column>
				<el-table-column label="仓库" align="center" width="120">
					<template slot-scope="scope">
						<span v-if="scope.row.delivery_type == 1">配送[{{scope.row.warehouse_name}}]</span>
						<span v-if="scope.row.delivery_type == 2">自提[{{scope.row.warehouse_name}}]</span>
					</template>
				</el-table-column>
				<el-table-column prop="leader_serial" label="序号" sortable="" align="center"
					width="100"></el-table-column>
				<el-table-column label="联系人" align="center" width="140">
					<template slot-scope="scope">
						<p>{{scope.row.contacts}}</p>
						<p>{{scope.row.phone}}</p>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="地址" align="center" width="200"></el-table-column>
				<el-table-column prop="category_title" label="商品分类" align="center" width="130"></el-table-column>
				<el-table-column prop="goods_name" label="商品名称" align="center" width="200">
					<template slot-scope="scope">
						<span v-if="searchForm.goods_name && scope.row.goods_name.indexOf(searchForm.goods_name)>=0"
							style="color:#5500ff;font-weight: 600;">{{ scope.row.goods_name }}</span>
						<span v-else>{{ scope.row.goods_name }}</span>
					</template>
				</el-table-column>
				<el-table-column label="商品图片" align="center" width="100">
					<template slot-scope="scope">
						<el-image style="width: 50px; height: 50px" :src="scope.row.goods_thumb"
							:preview-src-list="[scope.row.goods_pic]">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column label="商品状态" align="center" width="80">
					<template slot-scope="scope">
						<span v-if="scope.row.status == 0">待确认</span>
						<span v-if="scope.row.status == 1" style="color:#67C23A">已确认</span>
						<span v-if="scope.row.status == 2" style="color:#F56C6C">已延期</span>
						<span v-if="scope.row.status == 9">已取消</span>
					</template>
				</el-table-column>
				<el-table-column label="数量" align="center" width="180">
					<template #default="{ row,$index }">
						<div style="display: flex;flex-direction: column;align-items: center;">
							<p>订 {{ row.count }} </p>
							<p v-if="row.m_status != 0">配 {{ row.ck_count }}</p>
							<p v-else style="display: flex;flex-direction: row;align-items: center;">
								<span style="line-height: 60px;">配</span>
								<el-input :ref="'input'+$index" style="width:120px" type="number" v-model="row.ck_count"
									@keyup.enter.native="handleEnter(row,$index)" />
							</p>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="price" label="单价" align="center" width="120">
					<template slot-scope="scope">
						<div style="display: flex;flex-direction: column;align-items: left;">
							<p>订 {{ scope.row.price }} </p>
							<p>配 {{ scope.row.actual_price }}</p>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="amount" label="金额" align="center" width="120">
					<template slot-scope="scope">
						<div style="display: flex;flex-direction: column;align-items: left;">
							<p>订 {{ scope.row.amount }} </p>
							<p>配 {{ scope.row.ck_amount }}</p>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="180">
					<template slot-scope="scope">
						<el-button type="success" size="mini" v-if="scope.row.m_status == 0"
							@click.stop="handleActualPrice(scope.row)">结算价</el-button>
						<el-button type="warning" size="mini" v-if="scope.row.status == 0"
							@click.stop="handleDelay(2, scope.row)">延期</el-button>
						<el-button type="danger" size="mini" v-if="scope.row.status == 0"
							@click.stop="handleCancel(2, scope.row)">取消</el-button>
					</template>
				</el-table-column>
			</Table>
		</div>
		<!-- 延期 -->
		<el-dialog title="商品延期" :visible.sync="delayDialogVisible" :close-on-click-modal="false" v-el-drag-dialog
			width="30%">
			<el-form ref="form" :model="delayForm" label-width="100px">
				<el-form-item label="延期数量" v-if="delayType == 2">
					<el-input v-model="delayForm.count" placeholder="请输入延期数量"></el-input>
				</el-form-item>
				<el-form-item label="配货日期">
					<el-date-picker v-model="delayForm.date" type="date" placeholder="选择配送日期" value-format="yyyy-MM-dd"
						style="width:100%">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="提货方式" v-if="delayType == 2">
					<el-select v-model="delayForm.delivery_type" placeholder="请选择提货方式" style="width: 100%;">
						<el-option v-for="item in deliveryType" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="所属路线" v-if="delayType == 2 && delayForm.delivery_type == 1">
					<el-select v-model="delayForm.delivery_line_id" placeholder="请选择所属路线" style="width: 100%;">
						<el-option v-for="item in routeList" :key="item.id" :label="item.title" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="运费费用" v-if="delayType == 2 && delayForm.delivery_type == 1">
					<el-input v-model="delayForm.delivery_fee" placeholder="请输入运费费用"></el-input>
				</el-form-item>
				<el-form-item label="运费是否支付" v-if="delayType == 2 && delayForm.delivery_type == 1">
					<el-select v-model="delayForm.delivery_fee_status" placeholder="请选择运费是否支付" style="width: 100%;">
						<el-option v-for="item in deliveryFeeStatus" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click.stop="delayDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click.stop="delayConfirmFn">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 修改结算价 -->
		<el-dialog title="修改结算价" :visible.sync="priceDialog" :close-on-click-modal="false" v-el-drag-dialog width="30%">
			<el-form ref="form" :model="priceForm" label-width="100px">

				<el-form-item label="商品名称">
					<el-input v-model="priceForm.goods_name" placeholder="" disabled />
				</el-form-item>
				<el-form-item label="当前预订价">
					<el-input v-model="priceForm.old_price" placeholder="" disabled />
				</el-form-item>
				<el-form-item label="修改结算价">
					<el-input v-model="priceForm.price" type="number" placeholder="请输入最新结算价" />
				</el-form-item>
				<el-form-item label="修改成本价">
					<el-input v-model="priceForm.cost" type="number" placeholder="请输入最新成本价" />
				</el-form-item>
				<el-form-item label="修改范围">
					<el-select v-model="priceForm.all_goods" style="width: 100%;">
						<el-option v-for="item in priceAllGoodsSelect" :key="item.id" :label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
					<span style="color:red">只能修改【待处理】状态的商品结算价，已确认或已延期的配货单将被跳过</span>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click.stop="priceDialog = false">取 消</el-button>
				<el-button type="primary" @click.stop="priceConfirmFn" v-loading.fullscreen.lock="loading">确
					定</el-button>
			</span>
		</el-dialog>
		<!-- 确认配货数 -->
		<el-dialog title="确认配货数" :visible.sync="countDialog" :close-on-click-modal="false" v-el-drag-dialog width="30%">
			<el-form ref="form" :model="countForm" label-width="100px">

				<el-form-item label="商品名称">
					<el-input v-model="countForm.goods_name" placeholder="" disabled />
				</el-form-item>
				<el-form-item label="订单数">
					<el-input v-model="countForm.old_count" placeholder="" disabled />
				</el-form-item>
				<el-form-item label="实际配货数">
					<el-input v-model="countForm.count" type="number" placeholder="请输入实际配货数" />
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click.stop="countDialog = false">取 消</el-button>
				<el-button type="primary" @click.stop="countConfirmFn" v-loading.fullscreen.lock="loading">确
					定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getLodop
	} from '@/utils/CLodopfuncs.js'
	export default {
		data() {
			return {
				dateVal: [],
				searchForm: {
					begin: '',
					end: '',
					status: '',
					delivery_line_id: ''
				},
				tableData: [],
				loading: true,
				page: 1,
				pageNum: 10,
				total: 0,
				selectionList: [],
				typeList: [{
						id: 1,
						name: '正常'
					},
					{
						id: 2,
						name: '延期'
					},
				],
				// 状态
				statusType: [{
						id: 0,
						name: '未确认'
					},
					{
						id: 1,
						name: '已确认'
					},
					{
						id: 2,
						name: '已延期'
					},
					{
						id: 9,
						name: '已取消'
					}
				],
				routeList: [], //配送路线
				routeName: '',
				delayDialogVisible: false,
				delayType: '',
				batchDelayArr: [],
				delayForm: {},
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now() - 8.64e7;
					},
				},
				// 提货方式
				deliveryType: [{
						id: 1,
						name: '配送'
					},
					{
						id: 2,
						name: '自提'
					}
				],
				// 运费是否支付
				deliveryFeeStatus: [{
						id: 0,
						name: '未付'
					},
					{
						id: 1,
						name: '已付'
					}
				],
				delayDisabled: false, //批量延期
				priceAllGoodsSelect: [{
					id: 0,
					name: '仅修改当前订单',
				}, {
					id: 1,
					name: '相同配货日期订单',
				}],
				priceForm: {
					ckd_mx_ids: 0,
					goods_name: "",
					price: 0,
					cost: 0,
					old_price: 0,
					all_goods: 0
				},
				priceDialog: false,
				warehouseOptions: [],
				cateList: [],
				selectCate: [],
				countDialog: false,
				countForm: {
					ckd_mx_ids: 0,
					goods_name: "",
					count: 0,
					old_count: 0
				},
				inputList: []
			}
		},
		mounted() {
			// 时间
			this.dateVal = [this.getCurrentDate(), this.getCurrentDate()]
			this.searchForm.begin = this.dateVal[0]
			this.searchForm.end = this.dateVal[1]
			// 列表
			this.getList()
			this.getRouteList()
			this.checkNoDelivery()
			this.getCateList()
			this.getWarehouseList()
		},
		watch: {
			'selectionList': {
				deep: true,
				handler(newVal, oldVal) {
					console.log(newVal)
					// 批量延期
					const delayArr = newVal.every(i => {
						return i.status === 0
					})
					if (delayArr) {
						this.delayDisabled = true
					} else {
						this.delayDisabled = false
					}
				}
			}
		},
		methods: {
			//配货数量框按回车
			handleEnter(item, currentIndex) {
				//调接口
				this.countForm.ckd_mx_id = item.id
				this.countForm.goods_name = item.goods_name
				this.countForm.count = item.ck_count
				this.$http.post(`erp/v1/preck/modify_ck_count`, this.countForm).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.$message.success(msg)
					} else {
						this.$message.error(msg);
					}
				})
				// 计算下一行的索引
				const nextIndex = currentIndex + 1;

				// 检查下一行是否存在
				if (nextIndex < this.tableData.length) {
					// 使用 $nextTick 确保 DOM 更新
					this.$nextTick(() => {
						const nextInputRef = this.$refs['input' + nextIndex];
						if (nextInputRef) {
							nextInputRef.focus(); // 聚焦下一行的输入框
						}
					});
				} else {
					console.log('已经是最后一行');
				}
			},
			handleCkCount(item) {
				this.countForm.ckd_mx_id = item.id
				this.countForm.goods_name = item.goods_name
				this.countForm.old_count = item.count
				this.countForm.count = item.count
				this.countDialog = true
			},
			countConfirmFn() {
				this.loading = true
				this.$http.post(`erp/v1/preck/modify_ck_count`, this.countForm).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.countDialog = false
						this.$message.success(msg)
						this.getList()
					} else {
						this.$message.error(msg);
					}
				})
			},
			handleActualPrice(item) {
				this.priceForm.ckd_mx_id = item.id
				this.priceForm.goods_name = item.goods_name
				this.priceForm.old_price = item.price
				this.priceForm.price = item.actual_price
				this.priceForm.cost = item.cost
				this.priceDialog = true
			},
			priceConfirmFn() {
				this.loading = true
				this.$http.post(`erp/v1/preck/modify_actual_price`, this.priceForm).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.priceDialog = false
						this.$message.success(msg)
						this.getList()
					} else {
						this.$message.error(msg);
					}
				})
			},
			handleSearch() {
				this.page = 1
				this.searchForm.begin = this.dateVal[0]
				this.searchForm.end = this.dateVal[1]
				if (this.selectCate) {
					this.searchForm.cate_ids = this.selectCate.join(",")
				}
				this.getList()
				//window.localStorage.setItem("searchForm", this.searchForm)
			},
			checkNoDelivery() {
				this.$http.post(`erp/v1/preck/check_no_delivery`, {}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200 && data > 0) {

						this.$alert('今日有' + data + '件商品未生成配送单，请重新生成', '警告', {
							confirmButtonText: '确定',
							callback: action => {

							}
						});
					}
				});
			},
			getCateList() {
				this.$http.post(`erp/v1/goods_category/all`, {}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.cateList = data
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 仓库
			getWarehouseList() {
				this.$http.post(`erp/v1/warehouse/all`).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.warehouseOptions = data
					} else {
						this.$message.error(msg);
					}
				});
			},
			getList() {
				this.loading = true
				this.$http.post(`erp/v1/preck/lst_goods`, {
					page: this.page,
					pageNum: this.pageNum,
					...this.searchForm
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						this.tableData = data.rows
						this.total = data.total
						this.inputList = []
						this.tableData.forEach(item => {
							this.inputList.push('input' + item.id)
						})
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 获取当前年月日
			getCurrentDate() {
				const today = new Date();
				let year = today.getFullYear();
				let month = (today.getMonth() + 1).toString().padStart(2, '0');
				let day = today.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${day}`;
			},
			// 所属路线
			getRouteList() {
				this.$http.post(`erp/v1/delivery_line/all`).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						this.routeList = data
					} else {
						this.$message.error(msg);
					}
				});
			},
			// 选择表格数据
			selectionChange(e) {
				this.selectionList = e
				// 批量延期
				/* 				const delayArr = this.selectionList.every(i => {
									return i.status == 0
								})
								if (delayArr) {
									this.delayDisabled = true
								} else {
									this.delayDisabled = false
								} */
			},
			// 延期
			handleDelay(type, item) {
				this.delayType = type
				if (this.delayType == 1) {
					if (this.selectionList.length <= 0) {
						this.$message.error('请选择批量延期的数据');
						return
					}
				}
				if (type == 1) {
					this.selectionList.forEach(i => {
						this.batchDelayArr.push({
							pre_ckd_mx_id: i.id,
							count: i.count,
						})
					});
					this.delayForm.detail = JSON.stringify(this.batchDelayArr)
				} else {
					this.delayForm.pre_ckd_mx_id = item.id
				}
				this.delayDialogVisible = true
			},
			//取消
			handleCancel(type, item) {
				let pre_ckd_mx_id = []
				if (type == 1) {
					if (this.selectionList.length <= 0) {
						this.$message.error('请选择要取消的订单');
						return
					}
					this.selectionList.forEach(i => {
						pre_ckd_mx_id.push(i.id)
					})
				} else {
					pre_ckd_mx_id.push(item.id)
				}
				this.$confirm('确定要取消配货商品吗，取消后不可恢复?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http.post(`erp/v1/preck/batch_goods_cancel`, {
						detail: pre_ckd_mx_id.join(",")
					}).then((res) => {
						const {
							code,
							data,
							msg
						} = res.data
						if (code == 200) {
							this.$message.success("操作成功")
							this.getList()
						} else {
							this.$message.error(msg);
						}
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});

			},
			// 延期确认
			delayConfirmFn() {
				let url = this.delayType == 1 ? 'erp/v1/preck/batch_goods_delay' : 'erp/v1/preck/goods_delay'
				this.$http.post(`${url}`, {
					...this.delayForm
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					if (code == 200) {
						this.delayDialogVisible = false
						this.$message.success("操作成功")
						this.getList()
					} else {
						this.$message.error(msg);
					}
				});
			},
			handleExport(sort) {
				this.loading = true
				this.$http.post(`erp/v1/preck/lst_goods_summary`, {
					export: 1,
					export_sort: sort,
					...this.searchForm
				}).then((res) => {
					const {
						code,
						data,
						msg
					} = res.data
					this.loading = false
					if (code == 200) {
						window.open(data.url, '_self')
					} else {
						this.$message.error(msg);
					}
				});
			}
		},
	}
</script>

<style lang="scss" scoped></style>